import ca from './ca.json'
import terms from './terms'

const messages = {
  ...ca,
  terms,
}

export default messages
